
import { produce } from "immer";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import Axios from "../apis/axios";
import { NodeId } from "components/NodeId";

class Deferred {
  promise: Promise<any>;
  resolve!: (value?: any) => void;
  reject!: (reason?: any) => void;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
}

const createNotificationSlice = (set: (data: any) => void, get: () => any) => ({
  notificationDetails: {} as any,
  unreadNotifications: [],
  getAllNotifications: {},
  subscribedEquipmentsCalender:{},

  loadNotificationDetails: async (notificationNodeId: any, lang: String) => {
    try {
      if (get().isLoggedIn === true) {
        if (lang == undefined) {
          lang = "de";
        }
        const encodedNotificationNodeId =
          encodeURIComponent(notificationNodeId);

       

        const response = await Axios.get(
          `api/v1/notifications/${encodedNotificationNodeId}?lang=${lang}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const a = 10;

        if (response && response?.status == 200) {
          const equipmentNodeId =
            response?.data?.notification?.isnotificationof[0]?.equipment
              ?.nodeid;
          set(
            produce((state: any) => {
              state.notificationDetails[response.data.notification?.nodeid] =
                response.data.notification;
              const equipment: any =
                state.subscribedEquipments[equipmentNodeId];
              if (equipment?.hasnotification !== undefined) {
                const notificationIndex = equipment?.hasnotification.findIndex(
                  (item: any) => item.notification?.nodeid === notificationNodeId
                );
                if (notificationIndex > -1) {
                  equipment.hasnotification[notificationIndex] = response.data;
                } else {
                  equipment?.hasnotification.push(response.data);
                }
              }
            })
          );
          return response.data;
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      
      throw new Error(error as string);
    }
  },

  createNotification: (payload: any) => {
    
    const notificationPayload: any = {};

    if (payload.equipmentnodeid === undefined) {
      throw new Error();
    } else {
      notificationPayload.equipmentnodeid = payload.equipmentnodeid;
    }

    if (payload.lang === undefined) {
      notificationPayload.lang = get().lang;
    } else {
      notificationPayload.lang = payload.lang;
    }

    if (payload.nodeid === undefined) {
      notificationPayload.nodeid = new NodeId(
        "mesutronic.de",
        uuidv4()
      ).toUrl();
    }

    if (payload.usernodeid === undefined) {
      notificationPayload.usernodeid = get().userNodeId;
    } else {
      notificationPayload.usernodeid = payload.usernodeid;
    }

    if (payload.type === undefined) {
      notificationPayload.type = 0;
    } else {
      notificationPayload.type = payload.type;
    }

    if (payload?.status === undefined) {
      notificationPayload.status = 0;
    } else {
      notificationPayload.status = payload?.status;
    }

    if (payload.title === undefined) {
      notificationPayload.title = "";
    } else {
      notificationPayload.title = payload.title;
    }

    if (payload.description === undefined) {
      notificationPayload.description = "";
    } else {
      notificationPayload.description = payload.description;
    }

    if (payload.created === undefined) {
      notificationPayload.created = new Date().valueOf();
    } else {
      notificationPayload.created = payload.created;
    }

    const commandObjects = [];
    const attachmentCommandObjects = [];

    if (payload.attachments?.length > 0) {
      for (const item of payload.attachments) {
        const attachment = item.attachment;
        if (attachment.nodeid === undefined || attachment.nodeid === null) {
          attachment.nodeid = new NodeId("mesutronic.de", uuidv4()).toUrl();
        }
        const attachmentPayload = {
          isattachmentof: notificationPayload.nodeid,
          lang: notificationPayload.lang,
          nodeid: attachment.nodeid,
          file: attachment.file,
          title: attachment.title,
          description: attachment.description,
          specifier: "",
        };
        const fileToUpload = _.cloneDeep(attachment);
        fileToUpload.property = "file";
        const attachmentCommandObject = {
          parentNodeIds: [notificationPayload.nodeid],
          nodeId: attachment.nodeid,
          payload: attachmentPayload,
          filesToUpload: [fileToUpload],
          type: "create",
          task: "processCreateAttachmentCommand",
        };
        attachmentCommandObjects.push(attachmentCommandObject);
      }
    }

    const notificationCommandObject = {
      parentNodeIds: [notificationPayload.equipmentnodeid],
      nodeId: notificationPayload.nodeid,
      payload: notificationPayload,
      type: "create",
      task: "processCreateNotificationCommand",
    };

    commandObjects.push(notificationCommandObject, ...attachmentCommandObjects);
    

    const promises = get().enqueueCommands(commandObjects);

    return promises;
  },

  updateNotification: async (payload: any) => {
    let promises;
    const commandObjects = [];
    const attachmentCommandObjects = [];
    //check if the notification command is currently in progress

    if (payload.attachments?.length > 0) {
      for (const item of payload.attachments) {
        const attachment = item.attachment;
        if (attachment.nodeid === undefined || attachment.nodeid === null) {
          attachment.nodeid = new NodeId("mesutronic.de", uuidv4()).toUrl();
        }

        const attachmentPayload = {
          isattachmentof: payload.nodeid,
          lang: payload.lang,
          nodeid: attachment.nodeid,
          title: attachment?.title,
          description: attachment?.description,
          specifier: "",
        };
        const fileToUpload = _.cloneDeep(attachment);
        fileToUpload.property = "file";
        const attachmentCommandObject = {
          parentNodeIds: [payload.nodeid],
          nodeId: attachment.nodeid,
          payload: attachmentPayload,
          filesToUpload: [fileToUpload],
          type: "create",
          task: "processCreateAttachmentCommand",
        };
        attachmentCommandObjects.push(attachmentCommandObject);
      }
    }

    const updateCommandObject = {
      parentNodeIds: [payload.equipmentnodeid],
      nodeId: payload.nodeid,
      payload: payload,
      type: "update",
      task: "processUpdateNotificationCommand",
    };
    commandObjects.push(updateCommandObject, ...attachmentCommandObjects);
    promises = get().enqueueCommands(commandObjects);

    return promises;
  },

  deleteNotification: async (
    notificationNodeId: any,
    notificationOfNodeId: any
  ) => {
    await get().pauseCommandQueue();

    //delete the command object and all depedent command objects
    const wasInQueue = get().deleteCommand(notificationNodeId, "create");
    //check if the delete command is currently in progress
    const isDeleteInProcess =
      get().commandInProcess?.nodeId === notificationNodeId &&
      get().commandInProcess?.type === "delete"
        ? true
        : false;

    let promises;
    if (wasInQueue === false && isDeleteInProcess === false) {
      //the command was not in the queue anymore
      //so we need to create a delete command
      const payload: any = {};
      payload.nodeid = notificationNodeId;
      const deleteCommandObject = {
        parentNodeIds: [notificationOfNodeId],
        nodeId: notificationNodeId,
        payload: payload,
        type: "delete",
        task: "processDeleteNotificationCommand",
      };
      promises = get().enqueueCommands([deleteCommandObject]);
    } else {
      //the command was not yet sent to the server
      const promise = new Deferred();
      promise.resolve();
      promises = [promise];
    }
    //remove the notification from the state
    get().deleteNotificationFromState(notificationNodeId, notificationOfNodeId);

    get().resumeCommandQueue();

    return promises;
  },

  shareNotification: async (receiver: any, nodeid: any) => {
    try {
      if (get().isLoggedIn === true) {
        const user = get().user;
        let payload = {
          receiver: receiver,
          nodeid: nodeid,
          name: user.givenname + " " + user.surname,
        };

        const response = await Axios.post(
          "/api/v1/notifications/share",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              
            },
            timeout: 10000,
          }
        );

        if (response && response?.status == 200) {
          return;
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      throw new Error(error as string);
    }
  },

  getUnreadNotifications: async (userNodeId: String, lang:string) => {
    try {
      if (get().isLoggedIn === true) {
        if (userNodeId === undefined) {
          userNodeId = get().userNodeId;
        }
        if(lang === undefined){
          lang = "de"
        }
        const response = await Axios.get(
          `api/v1/notifications/unread?lang=${lang}`,
          {
            headers: {
              "Content-Type": "application/json",
              
            },
            timeout: 10000,
          }
        );
        if (response && response?.status == 200) {
          // Update the state using the set function
          set(
            produce((state: any) => {
              state.unreadNotifications = response.data;
            })
          );

          // Return the response data after updating the state
          return response.data;
        } else {
          alert("Error");
          throw new Error();
        }
      }
    } catch (error) {
      throw new Error(error as string);
    }
  },

  markNotificationRead: async (notificationNodeId: any) => {
    try {
      if (get().isLoggedIn === true) {
        const name = "UnReadNotifications";
        const keys = [notificationNodeId + get().userNodeId];
        const payload = { name, keys };
        const response = await Axios.post("api/v1/keyvalue/delete", payload, {
          headers: {
            "Content-Type": "application/json",
            
          },
          timeout: 10000,
        });

        if (response && response?.status == 200) {
          set(
            produce((state: any) => {
              delete state.unreadNotifications[notificationNodeId];
            })
          );
          return response.data;
        } else {
          alert("Error");
          throw new Error();
        }
      }
    } catch (error) {
      throw new Error(error as string);
    }
  },

  processCreateNotificationCommand: async (commandObject: any) => {
    try {
      
      if (get().isLoggedIn === true) {
        const response = await Axios.post(
          "api/v1/notifications",
          commandObject.payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 10000,
          }
        );

        const a = 10;

        if (response && response?.status == 200) {
          
          return response.data;
        } else {
          throw new Error();
        }
      } else {
        throw new Error();
      }
    } catch (error) {
    
      throw new Error(error as string);
    }
  },

  processUpdateNotificationCommand: async (commandObject: any) => {
    
    try {
      

      if (get().isLoggedIn === true) {
        const encodedNotificationNodeId = encodeURIComponent(
          commandObject.payload.nodeid
        );
        const response = await Axios.put(
          "/api/v1/notifications/" + encodedNotificationNodeId,
          commandObject.payload,
          {
            headers: {
              "Content-Type": "application/json",
               
            },
            timeout: 10000,
          }
        );

        if (response && response?.status == 200) {
          
          return;
        } else {
          throw new Error();
        }
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(error as string);
    }
  },

  processDeleteNotificationCommand: async (commandObject: any) => {
    try {
      

      if (get().isLoggedIn === true) {
        const encodedNotificationNodeId = encodeURIComponent(
          commandObject.payload.nodeid
        );

        const response = await Axios.delete(
          "/api/v1/notifications/" + encodedNotificationNodeId,
          {
            headers: {
              "Content-Type": "application/json",
             
            },
            timeout: 10000,
          }
        );

        if (response && response?.status == 200) {
          
          return;
        } else {
          throw new Error();
        }
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(error as string);
    }
  },

  createNewNotificationObject: (
    notificationCommandObject: any,
    attachmentCommandObjects: any,
    user: any
  ) => {
    const notification = _.cloneDeep(notificationCommandObject.payload);
    notification.isnotificationof = [
      {
        equipment: {
          nodeid: notificationCommandObject.payload.equipmentnodeid,
        },
      },
    ];

    notification.hasauthor = [{ user: user }];

    const attachments = [];

    if (attachmentCommandObjects?.length > 0) {
      for (const attachmentCommandObject of attachmentCommandObjects) {
        attachments.push({
          attachment: get().createNewAttachmentObject(attachmentCommandObject),
        });
      }
      notification.hasattachment = attachments;
    }

    return notification;
  },

  getNotifications: async (lang: String) => {
    try {
      if (get().isLoggedIn === true) {
        if (lang == undefined) {
          lang = "de";
        }
        const response = await Axios.get(`api/v1/notifications`, {
          headers: {
            "Content-Type": "application/json",
            
          },
        });

        if (response && response?.status == 200) {
          set(
            produce((state: any) => {
              state.getAllNotifications = response.data;
            })
          );

          // Return the response data after updating the state
          return response.data;
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      throw new Error(error as string);
    }
  },

  getNotificationsByEqs: async (lang: String,eqIds:any) => {
    
    try {
      if (get().isLoggedIn === true) {
        if (lang == undefined) {
          lang = "de";
        }
        let payload = {
          equipmentnodeids: eqIds,
          lang: "de",
        }
        const response = await Axios.post(`api/v1/notifications/equipments`,payload, {
          
          headers: {
            "Content-Type": "application/json",
           
            
          },
        });

        if (response && response?.status == 200) {
          set(
            produce((state: any) => {
              state.getAllNotifications = response.data.data.map((dt:any) => {return dt.equipment.hasnotification}).flat();
            })
          );

          // Return the response data after updating the state
          return response.data;
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      throw new Error(error as string);
    }
  },

});
export default createNotificationSlice;
